import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import Image from '../../../../atoms/Image';
import SocialMedia from '../../../../molecules/SocialMedia';
import InternalLink from '../../../../atoms/InternalLink';
import OutboundLink from '../../../../atoms/OutboundLink';

const CenterStackedBody = props => {
  const { pages, logo, bodyColor, socialMedia, pagesClassName } = props;

  const PagesSection = () =>
    pages.map(page => (
      <Grid.Row
        key={`footer-center-${page.title}`}
        style={{ paddingBottom: '5px', paddingTop: '5px' }}
      >
        {page.pages.map(pagesItem => {
          const columns = Math.floor(16 / page.pages.length);
          return (
            <Grid.Column
              width={columns}
              centered
              textAlign="center"
              className={pagesClassName}
              floated="right"
              key={`footer-center-${pagesItem.slug}`}
            >
              {pagesItem.internal ? (
                <InternalLink to={pagesItem.slug} label={pagesItem.pageTitle} />
              ) : (
                <OutboundLink to={pagesItem.slug} label={pagesItem.pageTitle} />
              )}
            </Grid.Column>
          );
        })}
      </Grid.Row>
    ));

  return (
    <div style={{ backgroundColor: bodyColor, paddingTop: '2.5em', paddingBottom: '2em' }}>
      <Grid style={{ paddingBottom: '2em' }}>
        <Grid.Column computer={6} tablet={6} mobile={2} />
        <Grid.Column computer={4} tablet={4} mobile={12} verticalAlign="middle" textAlign="center">
          <Image src={logo} centered fluid verticalAlign="middle" />
        </Grid.Column>
        <Grid.Column mobile={2} only="mobile" />
        <Grid.Column computer={5} tablet={5} textAlign="right" only="tablet computer">
          <SocialMedia socialMediaValues={socialMedia} buttonType="rect" />
        </Grid.Column>
        <Grid.Column mobile={16} textAlign="center" only="mobile">
          <SocialMedia socialMediaValues={socialMedia} buttonType="rect" />
        </Grid.Column>
        <Grid.Column computer={1} tablet={1} floated="right" only="tablet computer" />
      </Grid>
      <Grid stackable container>
        <PagesSection />
      </Grid>
    </div>
  );
};

CenterStackedBody.propTypes = {
  bodyColor: PropTypes.string.isRequired,
  pagesClassName: PropTypes.string,
};
CenterStackedBody.defaultProps = {
  pagesClassName: 'footer-pages',
};

export default CenterStackedBody;
